import { render, staticRenderFns } from "./RefreshJudgmentButton.vue?vue&type=template&id=5cea285c"
import script from "./RefreshJudgmentButton.vue?vue&type=script&lang=js"
export * from "./RefreshJudgmentButton.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports